module.exports = __webpack_public_path__ + "static/media/SubmitLeadSuccess.47f34f68.png";